import React, { useEffect, memo } from 'react'
import Styled from 'styled-components'
import { useSelector, useDispatch } from 'react-redux'
import { SET_SELECTED_FILTER, initialState, SET_SELECTED_FILTER_NUM } from 'estimate_list/reducers/initial'
import CategoryButton from './filter_category_button'
import { numberFormat, filterTheorem } from 'estimate_list/libs/util'

const FilterSelected = () => {
    const setSearchPriceOption = useSelector(state => state.initial.setSearchPriceOption)
    const selectedFilters = useSelector(state => state.initial.selectedFilters)
    const currentCategory = useSelector(state => state.category.currentCategory)
    const { maker, spec, kwd, min, max } = selectedFilters

    const dispatch = useDispatch()

    useEffect(() => {
        getDataLenth()
    }, [selectedFilters]) // eslint-disable-line

    const priceFomat = (low, high) => {
        let price = ''
        // if (!setSearchPriceOption.list || setSearchPriceOption.list?.length === 0) return
        const lastPrice = setSearchPriceOption.list[setSearchPriceOption.list.length - 1]
        if (low === 0) {
            price = `~ ${numberFormat(high)}원`
        } else if ((lastPrice && (lastPrice.lim_price_high <= high)) || !high) {
            price = `${numberFormat(low)}원 ~`
        } else {
            price = `${numberFormat(low)} ~ ${numberFormat(high)}원`
        }
        return price
    }

    const getDataLenth = () => {
        let len = 0
        const { spec, maker, min, max } = selectedFilters
        if (spec) {
            Object.keys(spec).forEach(v => (
                spec[v].forEach(() => (
                    len += 1
                ))
            ))
        }
        if (maker) {
            len += maker.length
        }
        if (min > 0 || max > 0) {
            len += 1
        }
        if (kwd) {
            len += 1
        }
        dispatch({
            type: SET_SELECTED_FILTER_NUM,
            data: len
        })
    }

    const deleteAll = () => {
        dispatch({
            type: SET_SELECTED_FILTER,
            data: initialState.selectedFilters
        })
    }

    const deleteBrand = (maker_id, maker_name) => () => {
        dispatch({
            type: SET_SELECTED_FILTER,
            data: filterTheorem(selectedFilters, {
                kind: 'brand',
                value: { maker_id, maker_name }
            })
        })
    }

    const deleteSpec = spec => () => {
        const { specNameKey, specValueKey, specValue } = spec
        dispatch({
            type: SET_SELECTED_FILTER,
            data: filterTheorem(selectedFilters, {
                kind: 'spec',
                value: { specNameKey, specValueKey, specValue }
            })
        })
    }

    const deleteKwd = () => {
        dispatch({
            type: SET_SELECTED_FILTER,
            data: filterTheorem(selectedFilters, {
                kind: 'kwd',
                value: ''
            })
        })
    }

    const deletePrice = () => {
        dispatch({
            type: SET_SELECTED_FILTER,
            data: filterTheorem(selectedFilters, {
                kind: 'price',
                value: [0, 0]
            })
        })
    }

    // console.log("priceFomat(min ,max) : ", priceFomat(min ,max))

    return (
        <>
            <Selected>
                <h4 className="blind">필터링 항목</h4>
                <button type="button" className="clear" onClick={deleteAll}><i className="icon-uniE9F9"/>전체해제</button>

                {/* {카테고리} */}
                {currentCategory.cate[0] && <CategoryButton />}

                {/* brand */}
                {maker.map(v => (
                    <button key={v.maker_id} type="button" className="pic" onClick={deleteBrand(v.maker_id, v.maker_name)}>
                        제조사 : {v.maker_name} <i className="icon-close"/>
                    </button>
                ))}

                {/* spec */}
                {Object.keys(spec).map(key => (
                    spec[key].map(v => (
                        <button key={v.specValueKey} type="button" className="pic" onClick={deleteSpec({specNameKey: v.specNameKey, specValueKey: v.specValueKey, specValue: v.specValue})}>
                            {v.specValue} <i className="icon-close"/>
                        </button>
                    ))
                ))}

                {/* kwd */}
                {kwd && (
                    <button type="button" className="pic" onClick={deleteKwd}>
                        검색어 : {kwd} <i className="icon-close"/>
                    </button>
                )}

                {/* price */}
                {(min !== 0 || max !== 0) && (
                    <button type="button" className="pic" onClick={deletePrice}>
                        가격 : {priceFomat(min ,max)} <i className="icon-close"/>
                    </button>
                )}
            </Selected>
        </>
    )
}

const Selected = Styled.div`
    border-top: 1px solid #c8c8c8;
    border-left: 1px solid #c8c8c8;
    background: #f7f7f7;
    line-height: 21px;
    padding: 9px 0 10px;

    button {
        border: 0;
        background: none;
        box-sizing: border-box
    }
    .clear {
        display: inline-block;
        overflow: hidden;
        height: 21px;
        margin-left: 20px;
        font-size: 12px;
        color: #333;
        vertical-align: top;

        i {
            width: 12px;
            height: 12px;
            font-size: 11px;
            display: inline-block;
            margin: 0 5px 0 0;
            vertical-align: middle;
        }

        &:after {
            display: inline-block;
            width: 1px;
            height: 10px;
            margin: 0 0 0 20px;
            background-color: #d8d8d8;
            vertical-align: middle;
            content: "";
        }
    }
    .pic {
        height: 21px;
        margin-left: 20px;
        color: #418ded;

        i {
            width: 13px;
            height: 13px;
            background: none;
            overflow: hidden;
            white-space: nowrap;
            text-indent: 0;
            display: inline-block;
            vertical-align: middle;
            color: #999;
        }
    }
`

export default memo(FilterSelected)



// WEBPACK FOOTER //
// ./src/estimate_list/components/filter/filter_selected.js